import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SessionService } from '../../app-lite/sessions/session.service';

@Component({
  template: require('./customer.vehicle.actions.component.html')
})
export class CustomerVehicleActionsComponent {
  @Input() record: any;

  @Output() onAddVVGarageClick   : EventEmitter<any> = new EventEmitter();
  @Output() onEditClick          : EventEmitter<any> = new EventEmitter();
  @Output() onEventClick         : EventEmitter<any> = new EventEmitter();
  @Output() onInvoiceClick       : EventEmitter<any> = new EventEmitter();
  @Output() onRemoveVVGarageClick: EventEmitter<any> = new EventEmitter();

  company = this.sessionService.company();
  session = this.sessionService.base();

  constructor (
    private sessionService: SessionService
  ) {}
}